<template>
  <div class="document-signed">
    <div class="full-frame-container">
      <!-- Embed Form -->
      <div class="embed-iframe">
        <iframe class="full-iframe" src="https://sway.cloud.microsoft/s/cQhF5mtyJ3pGWkmp/embed" frameborder="0" marginheight="0" marginwidth="0" max-width="100%" sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-same-origin allow-scripts" scrolling="no" style="border: none; max-width: 100%; max-height: 100vh" allowfullscreen mozallowfullscreen msallowfullscreen webkitallowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'document-signed',
  metaInfo () {
    console.log('metaInfo being called in Document Signed')
    const title = 'Tyng & Co | Document Signed'
    const description = 'Document Signed'
    document.querySelector('meta[name="description"]').content = description
    return {
      title,
      titleTemplate: null,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description
        }
      ],
      link: [{
        rel: 'canonical',
        href: `https://tyng-ca.com.my/${this.$i18n.locale}/document-signed`
      }]
    }
  }
}
</script>
